import intermind from '../../../index';
import { TranscriptWord } from '../types/transcript.types';

export class TranscriptResource {
  async get(conferenceId: string): Promise<TranscriptWord[]> {
    const { data } = await intermind.httpClient.get<TranscriptWord[]>(`/conferences/${conferenceId}/transcript`);
    return data;
  }
}
